import { QueryClient, useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { SubscriptionState } from '../../../admin/components/tools/UpgradeWizard/types';

interface UseSubscriptionStateQueryParams {
	accountId: string;
	enabled?: boolean;
}

function subscriptionStateQueryKey(accountId: string) {
	return ['subscriptionState', accountId];
}

export function invalidateSubscriptionState(queryClient: QueryClient, accountId: string) {
	return queryClient.invalidateQueries({
		queryKey: subscriptionStateQueryKey(accountId),
	});
}

export function useSubscriptionStateQuery({ accountId, enabled = true }: UseSubscriptionStateQueryParams) {
	const userSession = useAdminUserSession();

	return useQuery({
		queryKey: subscriptionStateQueryKey(accountId),
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<SubscriptionState>(
				`admin/BillingUtilities/GetSubscriptionStateByAccountId?accountId=${encodeURIComponent(accountId)}`,
				'GET'
			);
		},
		enabled: enabled && !!accountId,
		retry: false,
	});
}
